// Libs
import React, { ReactElement } from 'react';
import Link from 'next/link';
import { useSession } from 'next-auth/react';
import { NextSeo } from 'next-seo';
// UI components
import { Typography, Button } from 'ui-components';
// App
import {
  UserAccessContentCard,
  UserAccessContentCardContainer,
} from 'app-shared/lib/components/cards/blurred-content-card';
import { ActionButton, ActionButtons } from 'app-shared/lib/components/buttons';
import { USER_ACCESS_PAGES_URLS } from '../user-access.constants';

import styles from './page.module.scss';
import { AuthConfig } from '@/fragments/auth';

const UnauthorizedPage = (): ReactElement => {
  const { data: session, status } = useSession();
  const isSessionLoading = status == 'loading';

  const authenticatedMessageTemplate: ReactElement = (
    <>
      <Typography variant="body1" align="center">
        Vous ne disposez pas des autorisations suffisantes pour afficher cette page.
      </Typography>
      <ActionButtons>
        <Link href="/">
          <ActionButton role="button" color="tertiary" variant="contained" size="large" type="button">
            Retour à l&apos;accueil
          </ActionButton>
        </Link>
      </ActionButtons>
    </>
  );

  const unAuthenticatedMessageTemplate: ReactElement = (
    <>
      <Typography variant="body1" align="center">
        Vous devez être identifié et bénéficier des autorisations suffisantes pour afficher cette page.
      </Typography>
      <div className={styles.actions}>
        <Link href="/">
          <Button
            role="button"
            color="tertiary"
            variant="outlined"
            size="medium"
            type="button"
            className={`${styles.button}`}
          >
            Retour accueil
          </Button>
        </Link>
        <Link href={USER_ACCESS_PAGES_URLS['login']}>
          <Button
            role="button"
            color="tertiary"
            variant="contained"
            size="medium"
            type="button"
            className={`${styles.button}`}
          >
            Se connecter
          </Button>
        </Link>
      </div>
    </>
  );

  if (isSessionLoading) {
    return null;
  }

  return (
    <>
      <NextSeo noindex={true} />
      <UserAccessContentCardContainer>
        <UserAccessContentCard>
          {(session && authenticatedMessageTemplate) || unAuthenticatedMessageTemplate}
        </UserAccessContentCard>
      </UserAccessContentCardContainer>
    </>
  );
};

const authConfig: AuthConfig = {
  restrictedAccess: false,
};

UnauthorizedPage.authConfig = authConfig;

export default UnauthorizedPage;
